import api from "./client";
import type { AiAssistantAnswer } from "../types";

/**
 * AI Proje Asistanı: proje bağlamıyla soru/yanıt.
 * Backend sabit rol kontrolü yapar (admin/yonetici/sef); kullanıcı başına
 * 10 istek/saat rate limit vardır (429 dönebilir).
 */
export async function askAiAssistant(
  projectId: number,
  question: string,
): Promise<AiAssistantAnswer> {
  const response = await api.post("/api/v1/ai/ask", {
    project_id: projectId,
    question,
  });
  return response.data.data;
}

/**
 * AI Yönetici Özeti: projenin son 7 günlük metriklerinden Türkçe özet.
 * Backend sabit rol kontrolü yapar (admin/yonetici/sef; şef proje üyesi
 * olmalı); kullanıcı başına 10 istek/saat rate limit (429 dönebilir).
 */
export async function fetchAiExecutiveSummary(
  projectId: number,
): Promise<import("../types").AiExecutiveSummary> {
  const response = await api.get(`/api/v1/projects/${projectId}/ai/executive-summary`);
  return response.data.data;
}
